import { render, staticRenderFns } from "./serviceRecords.vue?vue&type=template&id=7e0864f6&scoped=true&"
import script from "./serviceRecords.vue?vue&type=script&lang=js&"
export * from "./serviceRecords.vue?vue&type=script&lang=js&"
import style0 from "./serviceRecords.vue?vue&type=style&index=0&id=7e0864f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0864f6",
  null
  
)

component.options.__file = "serviceRecords.vue"
export default component.exports